import { Button } from '@/components/ui-kit/button';
import { Loader2, RotateCcw, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ArchiveRowActions = ({
  isRestoreLoading,
  isDeleteLoading,
  handleUnArchive,
  handleMoveToTrash,
}: {
  isRestoreLoading: boolean;
  isDeleteLoading: boolean;
  handleUnArchive: () => void;
  handleMoveToTrash: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-end items-center gap-1.5">
      <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        className="text-selise-blue-500 hover:text-selise-blue-500/90"
        onClick={handleUnArchive}
        disabled={isRestoreLoading || isDeleteLoading}
      >
        <RotateCcw className={`size-5 ${isRestoreLoading ? 'animate-spin' : ''}`} />
        <span className="sr-only">{t('ORGARCHIVE_ACTION_RESTORE')}</span>
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        className="text-destructive hover:text-destructive/90"
        onClick={handleMoveToTrash}
        disabled={isRestoreLoading || isDeleteLoading}
      >
        {isDeleteLoading ? <Loader2 className={`size-5 animate-spin`} /> : <Trash2 className="size-5" />}

        <span className="sr-only">{t('ORGARCHIVE_ACTION_DELETE')}</span>
      </Button>
    </div>
  );
};

export default ArchiveRowActions;
